export const PLAID_CONFIG = {
  clientId: '6762daa620f5d1001b991867', // Make sure this matches your Plaid client ID
  env: 'sandbox' as const,
  products: ['auth', 'transactions'] as const,
  countryCodes: ['US'] as const,
  language: 'en' as const,
};
